import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css"

// const Alert = ({ alerts }) =>
//     alerts !== null &&
//     alerts.length > 0 &&
//     alerts.map((alert) => (
//         <div key={alert.id} className={`alert alert-${alert.alertType}`}>
//           {alert.msg}
//         </div>
//     ));

const Alert = ({alerts}) => {
    const prevAlert = useRef(null);
    useEffect(() => {
        prevAlert.ids = alerts.map((alert) => alert.id);
        prevAlert.msgs = alerts.map((alert) => alert.msg);
    }, [alerts]);

    alerts !== null &&
    alerts.length > 0 &&
    alerts.map((alert) => {
            if (alert.alertType === 'success' && !prevAlert.ids.includes(alert.id) && !prevAlert.msgs.includes(alert.msg))
                toast.success(alert.msg, toastOptions)
            else if (alert.alertType === 'error' && !prevAlert.ids.includes(alert.id) && !prevAlert.msgs.includes(alert.msg))
                toast.error(alert.msg, toastOptions)
            return null;
        }
    )

    return (
        <ToastContainer/>
    )
};

const toastOptions = {
    pposition: "button-right",
    autoClose: 1500,
    pauseOnHover: false,
    draggable: false,
    theme: "dark"
}

Alert.propTypes = {
    alerts: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
    alerts: state.alert,
});

export default connect(mapStateToProps)(Alert);
